import { getCrmCompanyId } from '@crm/shared/config'

const trimSlashes = (value: string) => value.replace(/^\/+|\/+$/g, '')

export const webApiRoute = (path: string) => `web-api/${trimSlashes(path)}`

export const companyApiRoute = (path: string) =>
  webApiRoute(`company/${getCrmCompanyId()}/${trimSlashes(path)}`)
